<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { RouteLocationNamedRaw } from 'vue-router'

import BaseSidebar from '~/components/molecules/BaseSidebar.vue'
import { useOrganization } from '~/composables/useOrganization'

const { t } = useI18n()
const { organization } = useOrganization()

type MenuItem = { to: RouteLocationNamedRaw; text: string }

const menus = computed<MenuItem[]>(() =>
  [
    {
      to: { name: 'organizationId-edit' },
      text: t('情報'),
    },
    {
      to: { name: 'organizationId-locations' },
      text: t('拠点'),
    },
    {
      to: { name: 'organizationId-users' },
      text: t('管理者'),
    },
    organization.value?.has_security_option && {
      to: { name: 'organizationId-security-settings' },
      text: t('セキュリティ設定'),
    },
  ].filter((item): item is Exclude<typeof item, undefined | false> => !!item)
)
</script>

<template>
  <aside class="root">
    <BaseSidebar :title="$t('組織設定')" :menus="menus" />
  </aside>
</template>

<style scoped lang="scss">
.root {
  width: 260px;
}
</style>
